import * as React from 'react';
import { mergeStyles } from '@cian/utils';

import styles from './Text.css';

interface IProps {
  type?: 'h4' | 'paragraph';
  color?: 'primary' | 'secondary';
  lineClamp?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  children: React.ReactNode;
  className?: string;
}

/**
 * @property type - меняeт стиль и размер шрифта
 * @property color - меняет цвет и оконтовку шрифта (text-shadow)
 * @property lineClamp - максимальное количество строк.
 * Строки, превышающие максимум - обрезаются троеточием.
 * Исключение - ie11: строки обрезаются, однако троеточие не добавляется.
 */
export const Text = ({ type = 'paragraph', color = 'primary', lineClamp, children, className }: IProps) => {
  const { className: rootClassName } = mergeStyles(
    styles['text'],
    styles[type],
    styles[color],
    lineClamp && styles[`line-clamp-${lineClamp}`],
    className,
  );

  return <div className={rootClassName}>{children}</div>;
};
